import { Connector } from '../../../api/connector'

export interface BulkDeleteRoutesArgs {
  readonly organizationUuid: string
  readonly applicationUuid: string
  readonly routeHashes: string[]
}

export async function bulkDeleteRoutes(
  this: { readonly connector: Connector },
  { organizationUuid, applicationUuid, routeHashes }: BulkDeleteRoutesArgs
) {
  return this.connector.executeDelete(
    `/${organizationUuid}/applications/${applicationUuid}/route/bulk`,
    {
      routeHashes
    }
  )
}
